export default __webpack_public_path__ + "static/media/bgSetings.bb261546.jpg";